var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{},[_vm._v("404")]),_c('div',[_vm._v(_vm._s(_vm.$t('404.MESSAGE')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }